import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Td, Text, useBreakpointValue, } from '@chakra-ui/react';
import format from 'date-fns/format';
export const DateCell = forwardRef(({ onClick, dateLocale, dateFormat, date, id, textProps, ...props }, ref) => {
    const defaultDateFormat = useBreakpointValue({ md: 'P', lg: 'PPP' }, { ssr: false });
    return (_jsx(Td, { ref: ref, onClick: onClick, display: { 'base': 'none', '2xl': 'table-cell' }, ...props, children: _jsx(Text, { variant: 'tableCell', ...textProps, children: format(new Date(date), dateFormat ?? defaultDateFormat ?? 'PPP', {
                locale: dateLocale,
            }) }) }, id));
});
